"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("../utils/propTypes/decorators");

var _DialogConstants = require("./DialogConstants");

var _AbstractModal = _interopRequireDefault(require("./internal/AbstractModal"));

var _ModalTransition = _interopRequireDefault(require("./internal/ModalTransition"));

var _UIModalDialog = _interopRequireDefault(require("./UIModalDialog"));

var _DropdownContext = require("../context/DropdownContext");

var UIModal = (0, _react.forwardRef)(function (props, ref) {
  var _useContext = (0, _react.useContext)(_DropdownContext.DropdownContext),
      shouldLogModalWarning = _useContext.shouldLogModalWarning;

  var _createPlacementWarning = (0, _DropdownContext.createPlacementWarning)(UIModal.displayName);

  if (shouldLogModalWarning) {
    _createPlacementWarning();
  }

  return _react.default.createElement(_AbstractModal.default, Object.assign({}, props, {
    componentName: "UIModal",
    Transition: _ModalTransition.default,
    ref: ref
  }));
});
UIModal.propTypes = Object.assign({}, _UIModalDialog.default.propTypes, {
  ModalDialog: (0, _decorators.hidden)(_propTypes.default.func),
  onCloseComplete: _propTypes.default.func,
  onCloseStart: _propTypes.default.func,
  onOpenComplete: _propTypes.default.func,
  onOpenStart: _propTypes.default.func,
  use: _propTypes.default.oneOf(Object.keys(_DialogConstants.MODAL_USE_CLASSES)).isRequired,
  _contextual: _propTypes.default.bool
});
UIModal.defaultProps = Object.assign({}, _UIModalDialog.default.defaultProps, {
  ModalDialog: _UIModalDialog.default,
  _contextual: false
});
UIModal.displayName = 'UIModal';
var _default = UIModal;
exports.default = _default;
module.exports = exports.default;